/* repX pages - scroll reveal (Phase 4, 13 Oct 2026). Plain JavaScript, no library. Runs on content pages only. */
(function () {
  var page = document.querySelector("main[data-template^='page']:not([data-template='page.about-us'])");
  if (!page || !('IntersectionObserver' in window)) return;
  var targets = page.querySelectorAll('.repx-section, .faq-item, .rtx__step, .rtx__time, .rtx__help, .repx-measure-grid > div, .repx-sg-footer');
  if (!targets.length) return;
  document.documentElement.classList.add('rx-js');
  var io = new IntersectionObserver(function (entries, obs) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-in');
        obs.unobserve(entry.target);
      }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
  Array.prototype.forEach.call(targets, function (el, i) {
    el.classList.add('rx-reveal');
    el.style.setProperty('--rx-d', (i % 4) * 80 + 'ms');
    io.observe(el);
  });
})();